import React, { useEffect, useRef, useState } from "react";
import { ChevronRight } from "lucide-react";

// Scroll-triggered reveal wrapper
export const Reveal = ({ children, className = "", delay = 0 }) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setInView(true);
          obs.unobserve(el);
        }
      },
      { threshold: 0.12 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      className={`reveal ${inView ? "in" : ""} ${className}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export const scrollToOrder = () => {
  const el = document.getElementById("order-form");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

// Big gold CTA button used throughout the funnel
export const CTAButton = ({ title, sub, className = "", onClick }) => (
  <button
    onClick={onClick || scrollToOrder}
    className={`cta-pulse group inline-flex flex-col items-center justify-center text-center rounded-xl px-7 py-4 sm:px-10 sm:py-5 font-semibold text-[#3a1002] transition-transform hover:scale-[1.02] active:scale-100 ${className}`}
    style={{
      background: "linear-gradient(180deg,#F2D06B 0%,#D4A62C 55%,#B8860B 100%)",
      border: "2px solid #8a6410",
    }}
  >
    <span className="font-display text-base sm:text-xl font-extrabold tracking-wide uppercase flex items-center gap-1">
      Order My Adrusta Ratnam Now
      <ChevronRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
    </span>
    {sub && <span className="text-[11px] sm:text-sm font-medium opacity-80 max-w-md leading-snug mt-0.5">{sub}</span>}
  </button>
);

export const SectionTitle = ({ kicker, title, light = false }) => (
  <div className="text-center mb-10">
    {kicker && (
      <span
        className={`inline-block font-marcellus tracking-[0.25em] text-xs sm:text-sm uppercase mb-3 ${
          light ? "text-[#E9C767]" : "text-[#B8860B]"
        }`}
      >
        {kicker}
      </span>
    )}
    <h2
      className={`font-display text-2xl sm:text-4xl font-bold leading-tight ${
        light ? "text-[#F4E3B8]" : "text-[#5A0B1D]"
      }`}
    >
      {title}
    </h2>
    <div className="section-divider w-28 mx-auto mt-4" />
  </div>
);
